import { readonly, ref, useContext } from "@nuxtjs/composition-api";
import { Logger } from "@wemade-vsf/core";
import { getGuestShippingMethodsCommand } from "./commands/getGuestShippingMethodsCommand";
import { getCustomerShippingMethodsCommand } from "./commands/getCustomerShippingMethodsCommand";
function useGetShippingMethods() {
  const loading = ref(false);
  const error = ref({ load: null });
  const { app } = useContext();
  const { context } = app;
  const load = async (params) => {
    Logger.debug("useGetShippingMethods/load", { params });
    let result = [];
    try {
      loading.value = true;
      const isGuest = params.cartId;
      result = await (isGuest ? getGuestShippingMethodsCommand.execute(context, params) : getCustomerShippingMethodsCommand.execute(context, params));
      Logger.debug("[Result]:", { result });
      error.value.load = null;
    } catch (err) {
      error.value.load = err;
      Logger.error("useGetShippingMethods/load", err);
    } finally {
      loading.value = false;
    }
    return result;
  };
  return {
    load,
    loading: readonly(loading),
    error: readonly(error)
  };
}
export * from "./useGetShippingMethods";
export {
  useGetShippingMethods
};
